import Cookie from 'js-cookie'
import OnAction from '~/utils/OnAction'
import { postData } from '~/utils/api'

export default class GetOrderInfo {
	constructor(data) {
		this.orderId = data.orderId
		this.currentDealer = data.currentDealer
		this.router = data.router
		this.locale = data.locale
		this.timezoneCode = data.timezoneCode
		this.browserTimezone = data.browserTimezone
		this.lastResult = {}
		this.timeLimit = 500
		this.onAction = new OnAction(this.currentDealer?.uuid, this.currentDealer?.name)
		this.requestUrl = '/api/v1/order-info'
	}

	async process() {
		let result = {}
		let isLastResultValid = false
		if (this.lastResult) {
			if ((Date.now() - this.lastResult.date) < this.timeLimit) {
				isLastResultValid = true
			}
		}
		if (isLastResultValid) {
			result = this.lastResult.data
		} else {
			const data = { 
		        selectedOrder: this.orderId,
		        timezoneCode: this.timezoneCode,
		        browserTimezone: this.browserTimezone,
	        }
	        this.onAction.send({
	            action: 'Order info request',
	            actionData: {
	              file: '/components/GetOrderInfo.ts',
	              requestUrl: this.requestUrl,
	              requestData: data,
	            },
	        })
	        const headers = {
	            currentDealer: this.currentDealer.id,
	            locale: this.locale,
	            access_token: Cookie.get('access_token'),
	            access_realm: Cookie.get('access_realm'),
          	}
	        const requestResult = await postData(this.requestUrl, data, headers)
	        if (requestResult?.error === 'Access forbidden') {
	          this.router.push('/login')
	        } else {
	        	this.lastResult = {
	        		date: Date.now(),
	        		data: requestResult,
	        	}
	        	result = requestResult
	        }
		}
		this.result = result
		return result
	}
}
	